module.exports = __webpack_public_path__ + "img/7.6c86cad6.png";